import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, renderSlot as _renderSlot, Transition as _Transition, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-select__choose" }
const _hoisted_2 = {
  key: 0,
  class: "p-select__items"
}
const _hoisted_3 = ["placeholder", "disabled"]
const _hoisted_4 = { class: "p-popover__content" }
const _hoisted_5 = {
  key: 0,
  class: "p-select__container"
}
const _hoisted_6 = { class: "p-select__items" }

import { computed, ref, nextTick, onMounted, onBeforeUnmount, PropType } from 'vue';
import Popper from 'vue3-popper';
import pSelectItem from '@/common/pSelect/pSelectItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'pSelect',
  props: {
  selectionItems: {
    type: Array as PropType<{ id: number|string; name: string }[]>,
    required: true
  },
  modelValue: {
    type: [String, Number, Array, null] as PropType<null | number | string | (number | string)[]>,
    required: true
  },
  placeholder: {
    type: String,
    default: 'Поиск...'
  },
  multiple: {
    type: Boolean,
    default: false
  },
  isIcon: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  close: {
    type: Boolean,
    default: false
  },
  valid: {
    type: Boolean,
    default: true
  },
  validInfo: {
    type: String,
    default: ''
  },
  isTooltip: {
    type: Boolean,
    default: false
  },
  tooltipProps: {
    type: Object,
    default: () => ({})
  },
  tooltipInfo: {
    type: String,
    default: ''
  },
  limit: {
    type: Number,
    default: 0
  },
  actionButton: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue', 'action', 'removeItem'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const search = ref<string>('');
const isOpenSelection = ref(false);

const selectRef = ref<HTMLElement | null>(null);
const searchInput = ref<HTMLElement | null>(null);

// TODO: заменить это на блюр
onMounted(() => document.addEventListener('click', handleClickOutside));
onBeforeUnmount(() => document.removeEventListener('click', handleClickOutside));

const handleClickOutside = (event: MouseEvent) => {
  if (selectRef.value && !selectRef.value.contains(event.target as Node)) {
    isOpenSelection.value = false;
  }
};

const action = () => {
  toggle()
  emit('action')
}

const selectedItems = computed(() => {
    if (props.multiple) {
      const itemsMap = new Map(props.selectionItems.map(item => [item.id, item]));
      return (props.modelValue as (number | string)[])
        .map(id => itemsMap.get(id))
        .filter((item): item is { id: number | string; name: string } => item !== undefined);
    }

    return [props.selectionItems.find(item => item.id === props.modelValue) || props.selectionItems[0]];
  }
);

function isActive(itemId: number | string ) {
  return props.multiple ? (props.modelValue as (number | string)[]).includes(itemId) : props.modelValue === itemId
}

const selectionItemsSearched = computed(() => {
  if (!props.multiple) return props.selectionItems
  if (!search.value || search.value.length === 0) return props.selectionItems

  return props.selectionItems.filter(item => item.name.toLowerCase().includes(search.value.toLowerCase()));
});

const classes = computed(() => ({
  'p-select_default': true,
  'p-select_opened': isOpenSelection.value,
  'p-select_disabled': props.disabled,
  'p-select_error': !props.valid,
  'p-select_multiple': props.multiple,
  'p-select_limit-reached': isLimitReached.value
}));

const cTooltipInfo = computed(() => props.tooltipInfo || props.validInfo);

const isLimitReached = computed(() => {
  if (!props.limit || !props.multiple) return false;
  return (props.modelValue as (number | string)[]).length >= props.limit;
});

const toggle = async () => {  
  if (props.disabled) return;
  isOpenSelection.value = !isOpenSelection.value;
  if (props.multiple && isOpenSelection.value) {
    searchInput.value?.focus()
  }
  await nextTick();
};

const selectItem = (item: { id: number | string; name: string }) => {
  if (props.multiple) {
    const selectedArray = props.modelValue as (number | string)[];
    
    if (!selectedArray.includes(item.id) && isLimitReached.value) {
      return;
    }

    emit('update:modelValue', selectedArray.includes(item.id)
      ? selectedArray.filter(id => id !== item.id)
      : [...selectedArray, item.id])
  } else {
    emit('update:modelValue', item.id)
  }
  
  isOpenSelection.value = false
  search.value = ''
};

const removeItem = (itemId: number | string) => {  
  if (props.multiple) {
    emit('update:modelValue', (props.modelValue as (number | string)[]).filter(id => id !== itemId))
  } else {
    emit('removeItem', itemId)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "selectRef",
    ref: selectRef,
    class: _normalizeClass(["p-select", classes.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.multiple)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedItems.value, (item) => {
              return (_openBlock(), _createBlock(pSelectItem, {
                key: item.id,
                item: item,
                close: true,
                onCloseClick: ($event: any) => (removeItem(item.id)),
                class: "p-select-item-active"
              }, null, 8 /* PROPS */, ["item", "onCloseClick"]))
            }), 128 /* KEYED_FRAGMENT */)),
            _withDirectives(_createElementVNode("input", {
              ref_key: "searchInput",
              ref: searchInput,
              class: "p-select__search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              placeholder: isLimitReached.value ? `Достигнут лимит (${__props.limit})` : __props.placeholder,
              onInput: _cache[1] || (_cache[1] = ($event: any) => (!isLimitReached.value && (isOpenSelection.value = true))),
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (!isLimitReached.value && (isOpenSelection.value = true))),
              disabled: isLimitReached.value
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3), [
              [_vModelText, search.value]
            ])
          ]))
        : (_openBlock(), _createBlock(pSelectItem, {
            key: 1,
            "is-icon": __props.isIcon,
            item: selectedItems.value[0],
            onClick: _cache[3] || (_cache[3] = ($event: any) => (isOpenSelection.value = true)),
            class: "p-select__item"
          }, null, 8 /* PROPS */, ["is-icon", "item"])),
      _createElementVNode("i", {
        class: "p-icon p-icon-arrow",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (!isLimitReached.value && toggle()))
      }),
      _createCommentVNode(" Tooltip "),
      (__props.isTooltip)
        ? (_openBlock(), _createBlock(_unref(Popper), _mergeProps({ key: 2 }, __props.tooltipProps, { class: "p-select__popover" }), {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(cTooltipInfo.value), 1 /* TEXT */)
            ]),
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass(["p-icon p-icon-info", {'p-icon-error': !__props.valid && __props.tooltipInfo.length === 0}])
              }, null, 2 /* CLASS */)
            ]),
            _: 1 /* STABLE */
          }, 16 /* FULL_PROPS */))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(_Transition, { name: "p-select" }, {
      default: _withCtx(() => [
        (isOpenSelection.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectionItemsSearched.value, (item) => {
                  return (_openBlock(), _createBlock(pSelectItem, {
                    key: item.id,
                    class: _normalizeClass(["p-select__item", {'p-select-item-active': isActive(item.id)}]),
                    close: __props.close,
                    item: item,
                    "is-icon": __props.isIcon,
                    onClick: () => selectItem(item),
                    onCloseClick: ($event: any) => (removeItem(item.id))
                  }, null, 8 /* PROPS */, ["class", "close", "item", "is-icon", "onClick", "onCloseClick"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              (__props.actionButton)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "p-select__action",
                    onClick: action
                  }, [
                    _renderSlot(_ctx.$slots, "action")
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 3 /* FORWARDED */
    })
  ], 2 /* CLASS */))
}
}

})